import axios from "axios";

const state = {
  courses: [],
  selectedCourse: null,
};
const mutations = {
  SET_COURSES(state, courses) {
    state.courses = courses;
  },
  SET_SELECTED_COURSE(state, course) {
    state.selectedCourse = course;
  },
};
const actions = {
  async loadCourses({ commit }) {
    try {
      const response = await axios.get("/data/courses.json");
      commit("SET_COURSES", response.data);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  },
  selectCourse({ commit, state }, courseSlug) {
    const course = state.courses.find((course) => course.slug === courseSlug);
    commit("SET_SELECTED_COURSE", course);
  },
};
const getters = {
  getCourses: (state) => state.courses,
  selectedCourse: (state) => state.selectedCourse,
  courseNames: (state) =>
    state.courses.map((course) => ({
      slug: course.slug,
      title: course.title,
    })),
};

export default {
  state,
  mutations,
  actions,
  getters,
};
